import { ShowUserModalForm } from "./ShowUserModalForm"


const ShowUserModalFormWrapper = () => {
    return (<ShowUserModalForm />)
}

export {ShowUserModalFormWrapper}